import { FeatureFlags } from '@constants/featureFlags';

export const ShortPayAdminRoute = {
  path: '/short-pay-admin',
  load: () => import('./ShortPayAdmin'),
  protected: true,
  featureFlag: FeatureFlags.ShortPayAdmin,
};
